import PropTypes from "prop-types";
import styles from "./index.css";
import { withTranslation } from "../../translation";
import getCopyKeys from "./getCopyKeys";
import useCountdown from "../../hooks/useCountdown";
import { formatCountdownTime } from "./formatCountdownTime";
import { formatDateForLoyalty } from "./formatDateForLoyalty";
import getTapingKey from "./getTapingKey";
import Icon from "../../Icon";

const getTapingText = ({
  customerAccess,
  showCountdown,
  remainingSeconds,
  endDate,
  formatTranslation,
}) => {
  const tapingKey = getTapingKey(customerAccess, showCountdown);

  if (!tapingKey) return null;

  return showCountdown
    ? formatTranslation(tapingKey, {
        time: formatCountdownTime(remainingSeconds),
      })
    : formatTranslation(tapingKey, { date: formatDateForLoyalty(endDate) });
};

const CategoryHeaderCopy = ({
  header,
  isComingSoon,
  endDate,
  formatTranslation,
  scrollFunction,
  customerAccess,
}) => {
  const copyKeys = getCopyKeys(isComingSoon);
  const { remainingSeconds, showCountdown } = useCountdown(endDate);

  const tapingText = getTapingText({
    customerAccess,
    showCountdown,
    remainingSeconds,
    endDate,
    formatTranslation,
  });

  return (
    <div className={styles.copy}>
      <div className={styles.constrained}>
        <Icon icon="asos-world" className={styles.asosWorldLogo} />
        <p className={styles.header}>{header}</p>
        {tapingText && <p className={styles.eapLabel}>{tapingText}</p>}
        <button
          type="button"
          className={styles.scrollToButton}
          onClick={scrollFunction}
        >
          {formatTranslation(copyKeys.buttonText)}
        </button>
      </div>
    </div>
  );
};

CategoryHeaderCopy.propTypes = {
  customerAccess: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  isComingSoon: PropTypes.bool.isRequired,
  endDate: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  scrollFunction: PropTypes.func.isRequired,
};

export default withTranslation(CategoryHeaderCopy);
